/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, disable } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTENT ANALYTICS CARD : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	contentanalyticscard: {
		background: '#FFFFFF',
		borderRadius: pxToEm(5),
		border: replacePXinStringWithEM(`1px solid #ECF0F7`),
		boxShadow: replacePXinStringWithEM(`0 1px 1px 0 #EDF1FA`),
		minHeight: pxToEm(420), //pxToEm(450),
		minWidth: pxToEm(225),
		padding: pxToEm(8),
		position: 'relative',
		'&:hover': {
			boxShadow: theme.boxShadow.highlightCard
		},
		'& .status, .contenttype': {
			pointerEvents: 'none'
		},
		'&.disabled-true':{
            extend: disable,
            filter: `grayscale(1) opacity(0.45)`
		},
		'& .status':{
			paddingRight: pxToEm(10),
			display:'flex',
			alignItems:'center',
			'& .text': {
				fontSize: pxToEm(12),
				marginLeft: pxToEm(10),
			}
		},
		// ----- identity ----- //
		'& .name-identity': {
			display: 'flex',
			justifyContent: 'space-between',
			marginBottom: pxToEm(12)
		},

		// ----- content ----- //
		'& .name-content': {
			color: theme.color.supporting.dark.swatch,
			marginBottom: pxToEm(80),
			'& .question': {
				extend: theme.typography.size.small,
				lineHeight: '1.3',
				// height: pxToEm(120),
				marginBottom: pxToEm(22)
			},
			'& .answers': {
				'& .answer': {
					extend: theme.typography.size.small,
					fontWeight: '500',
					marginBottom: pxToEm(6),
					display: 'flex',
					alignItems: 'center',
					alignContent: 'center',
					'& .visual': {
                        width: 'fit-content',
                        height: 'fit-content',
						marginRight: pxToEm(8),
						'& .image': {
							backgroundColor: 'transparent',
							backgroundRepeat: 'no-repeat',
							backgroundPosition: '50%',
							backgroundSize: 'cover',
							borderRadius: '100%',
                            width: pxToEm(48),
                            height: pxToEm(48),
						},
						'& .emoji':{
                        	fontSize: pxToEm(36)
						}
					},
					'& .info': {
						flex: '1',
						'& .details': {
							display: 'flex',
							alignItems: 'space-between',
							alignContent: 'space-between',
							justifyContent: 'space-between',
							marginBottom: pxToEm(7),
							'& .correct-answer': {
								fontSize: pxToEm(12),
								margin: replacePXinStringWithEM(`10px 0`),
								fontWeight: '400',
								'& .icon': {
									background: theme.color.quiz.medium.swatch,
									color: theme.color.light.light.swatch,
									borderRadius: '100%',
									width: pxToEm(25),
									height: pxToEm(25),
									textAlign: 'center',
									display: 'inline-block',
									verticalAlign: 'bottom',
									lineHeight: 1.8
								}
							}
						},
						'& .details.bold-true': {
							fontWeight: '600'
						}
					},
					// question types
					'&.text1, &.text2': {
						'& .visual': {
							display: 'none'
						}
					},
					'&.image2': {
						'& .visual': {
							'& .image': {
								borderRadius: pxToEm(4)
							}
						}
					}
				}
			}
		},

		// ----- trailing ----- //
		'& .name-trailing': {
			width: '100%',
			position: 'absolute',
			bottom: pxToEm(8),
			right: pxToEm(8),
			textAlign: 'right',
			'& .total': {
				extend: theme.typography.size.small,
				textAlign: 'right',
				fontWeight: '600',
				marginBottom: pxToEm(15),
				'& .totalnumber': {
					color: theme.color.primary.medium.swatch
				}
			},
			'& .ctas': {
				justifyContent: 'flex-end'
			}
		}
	}
});